module.exports = __webpack_public_path__ + "img/sycamore_logo.53f27051.svg";